export default function TermsPage() {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl md:text-5xl font-bold text-primary mb-8">
          Terms of Service
        </h1>
        
        <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
          <p className="text-lg">
            <strong>Last Updated:</strong> January 2025
          </p>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Circulate Travel's services, you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">2. Booking and Payment</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>All bookings are subject to availability and confirmation</li>
              <li>Prices are quoted in USD unless otherwise specified</li>
              <li>Payment plans are available for qualifying purchases</li>
              <li>Full payment must be received before departure</li>
              <li>A deposit may be required to secure your booking</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">3. Cancellation Policy</h2>
            <p>Cancellation fees vary based on timing:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>60+ days before departure:</strong> Full refund minus processing fee</li>
              <li><strong>30-59 days before departure:</strong> 50% refund</li>
              <li><strong>Less than 30 days:</strong> No refund (credit may be available)</li>
            </ul>
            <p>
              We strongly recommend travel insurance to protect against unforeseen circumstances.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">4. Travel Requirements</h2>
            <p>You are responsible for:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Valid passport and any required visas</li>
              <li>Meeting health requirements (vaccinations, COVID-19 protocols if applicable)</li>
              <li>Travel insurance (strongly recommended)</li>
              <li>Arriving on time for scheduled activities</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">5. Limitation of Liability</h2>
            <p>
              Circulate Travel acts as an agent for third-party service providers (hotels, airlines, tour operators). 
              We are not liable for any injury, damage, loss, or delay caused by these providers or circumstances 
              beyond our control.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">6. Changes to Itinerary</h2>
            <p>
              We reserve the right to modify itineraries due to weather, safety concerns, or other factors beyond 
              our control. We will make reasonable efforts to provide comparable alternatives.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">7. Code of Conduct</h2>
            <p>Travelers are expected to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Respect local customs and cultures</li>
              <li>Follow instructions from tour guides</li>
              <li>Behave responsibly and considerately toward other travelers</li>
              <li>Not engage in illegal activities</li>
            </ul>
            <p>
              We reserve the right to remove anyone whose behavior negatively impacts the group experience.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">8. Photo & Video Release</h2>
            <p>
              By participating in any Circulate Travel tour or experience, you grant Circulate Travel, its affiliates, 
              and authorized representatives the irrevocable, perpetual, worldwide, royalty-free right and license to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Capture Media:</strong> Photograph, film, and record you during any tour, activity, or event
              </li>
              <li>
                <strong>Use for Marketing:</strong> Use, reproduce, modify, publish, and distribute such photos, videos, 
                and recordings for marketing, promotional, advertising, and commercial purposes
              </li>
              <li>
                <strong>Real-Time Sharing:</strong> Share content in real-time on social media platforms, websites, 
                live streams, and other digital channels
              </li>
              <li>
                <strong>Future Use:</strong> Retain and use captured media indefinitely for future marketing campaigns, 
                brochures, website content, social media, and any other promotional materials
              </li>
            </ul>
            <p className="mt-4">
              This release includes the use of your name, likeness, image, voice, and biographical information in 
              connection with the media captured. You waive any right to inspect or approve the finished materials 
              and release Circulate Travel from any claims arising from such use.
            </p>
            <p className="mt-4">
              If you do not wish to be photographed or filmed, please notify your tour guide at the beginning of 
              your trip. While we will make reasonable efforts to accommodate such requests, we cannot guarantee 
              complete exclusion from group photos or video footage.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">9. Contact</h2>
            <p>
              For questions about these Terms, please contact us at{' '}
              <a href="mailto:info@circulatetravel.com" className="text-secondary hover:underline">
                info@circulatetravel.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
